module.exports = __webpack_public_path__ + "static/3-anticonquista-cafe-5f51717fecfb3e4b1b7d0129904b04f0.jpg";